function getWindow() {
  return global.window
}

const window = getWindow()

export { window }
